import template from './loansMandatoryInsuranceModal.html';
import controller from './loansMandatoryInsuranceModal.controller';
import './loansMandatoryInsuranceModal.scss';

let loansMandatoryInsuranceModalComponent = {
  restrict: 'E',
  bindings: {
    error: '<',
    message: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansMandatoryInsuranceModalComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansMandatoryInsuranceModal/loansMandatoryInsuranceModal.component.js